export default {
    debug: true,

    logReduxActions: true,

    ga: {
        logEnabled: true
    },

    searchAssociatesSite: {
        secure: false,
        host: "test.searchassociates.com",
        path: "/"
    },

    webApi: {
        secure: false,
        host: "api.apli-demo.local",
        path: "/"
    }
};



// WEBPACK FOOTER //
// ./src/config/env/demo.js